import { useNavigate } from 'react-router-dom'
import { AppButton, Typography } from '@/components/app'
import { Home } from 'lucide-react'
import { useTheme } from '@/components/themeComponent/useTheme'

export default function NotFound() {
  const navigate = useNavigate()
  useTheme()

  return (
    <div className="flex flex-col items-center justify-center min-h-screen gap-4">
      <h1 className="text-[6vw] font-bold text-foreground/50 leading-none">404</h1>
      <Typography variant='h5'>Page not found</Typography>
      <AppButton onClick={() => navigate('/')} startIcon={<Home size={20}/>}> Go Home</AppButton>
    </div>
  )
}
